import styled from 'styled-components';
import {ListTitleDefaultBox} from './list-title.default.box';

export const ListTitleMrGreenBox = styled(ListTitleDefaultBox)`
    padding-left: 0;
    &:before {
        content: none
    }
`;
